export const STATUS_ADAPTER = {
	open: 'Abierta',
	close: 'Cerrada',
};
